import React, { useState } from 'react';

export default function GridImage({
  node, // { url, width, height }
  alt = '',
  className = '',
  sizes = '(max-width:768px) 50vw, (max-width:1024px) 33vw, 25vw',
}) {
  const [loaded, setLoaded] = useState(false);
  const aspect = node?.width && node?.height ? node.width / node.height : (4 / 5);

  return (
    <div className={`relative overflow-hidden ${className}`} style={{ aspectRatio: aspect }}>
      <div
        className="absolute inset-0 bg-white animate-pulse"
        style={{ opacity: loaded ? 0 : 1, transition: 'opacity 200ms ease' }}
      />
      <img
        src={node?.url || ''}
        alt={alt}
        className="absolute inset-0 w-full h-full object-contain"
        loading="lazy"
        decoding="async"
        sizes={sizes}
        onLoad={() => setLoaded(true)}
        style={{ opacity: loaded ? 1 : 0, transition: 'opacity 200ms ease' }}
      />
    </div>
  );
}
